export default "<div appScroll\n     (scrollChange)=\"scrollServices.onScrollChanges($event)\"\n>\n  <router-outlet></router-outlet>\n</div>\n"